import styled from "styled-components";

export const Title = styled.div`
  font-size: 28px;
  display: flex;
  align-items: center;
  font-weight: bold;
  svg {
    margin-right: 8px;
  }
`;

export const ButtonContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  flex: 1;
`;

export const Text = styled.p`
  font-size: 22px;
  margin: 0;
`;

export const RegistrationText = styled.div`
  margin: 10px 0;
  font-size: 20px;
  font-weight: 500;
  color: #484848;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const CardInformation = styled.div`
  margin: 30px 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  @media only screen and (max-width: 450px) {
    margin: 15px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0;
  width: 100%;
`;

export const IconWrapper = styled.div`
  margin-right: 15px;
  border-radius: 50%;
  min-width: 60px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.color.lightBlue};
  color: ${(props) => props.theme.color.darkBlue};
`;

export const TextWrapper = styled.div`
  background: ${(props) => props.theme.color.lightPink};
  width: 100%;
  padding: 10px 20px;
  border-radius: 28px;
`;

export const Image = styled.div<{ src: string }>`
  background-image: url(${({ src }) => src});
  height: 400px;
  border-radius: 12px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingWrapper = styled.div`
  height: 200px;
`;
